/* Horizon ki base.css @layer ke andar hai, aur layered !important hamare !important ko
   haraa deta hai. Isliye tile ka rang inline style se lagana padta hai.
   THEME A — card safed, gallery par purple->green gradient, quick-add purple. */
(function () {
  var CARD     = '#FFFFFF';
  var GALGRAD  = 'linear-gradient(148deg,#F4EDF6 0%,#FDFCFD 50%,#EDF7EA 100%)';
  var QA       = 'linear-gradient(180deg,#573460 0%,#3E2545 100%)';
  var QA_HOVER = 'linear-gradient(180deg,#2E7322 0%,#265E1C 100%)';

  var SEL = [
    'product-card',
    '.collection-card',
    '[id$=__carousel_concern] .card',
    '[id$=__section_9fJNWm] .group-block .group-block'
  ].join(',');
  var GALLERY = 'product-card [class*=card-gallery], .collection-card [class*=collection-image]';
  var QABTN   = 'product-card button.quick-add__button, .product-card button.quick-add__button';

  function paint() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.dataset.poochTile === '1') return;
      el.dataset.poochTile = '1';
      el.style.setProperty('background', CARD, 'important');
    });
    document.querySelectorAll(GALLERY).forEach(function (el) {
      if (el.dataset.poochTile === '1') return;
      el.dataset.poochTile = '1';
      el.style.setProperty('background', GALGRAD, 'important');
    });
    document.querySelectorAll(QABTN).forEach(function (el) {
      if (el.dataset.poochQa === '1') return;
      el.dataset.poochQa = '1';
      el.style.setProperty('background', QA, 'important');
      el.style.setProperty('color', '#CDEBC8', 'important');
      var card = el.closest('product-card') || el.closest('.product-card');
      if (!card) return;
      card.addEventListener('mouseenter', function () { el.style.setProperty('background', QA_HOVER, 'important'); });
      card.addEventListener('mouseleave', function () { el.style.setProperty('background', QA, 'important'); });
    });
  }

  var t;
  function run() { clearTimeout(t); t = setTimeout(paint, 80); }
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  run();
})();
